import type { QueryClient } from '@tanstack/react-query';

import { apiQuery, createQueryKeys } from '@/shared/data';

import { fromApiDataModel, type PermissionModel } from './model';
import { getEffectivePermissions } from './permission.api';
import type { PermissionEntry } from './permission.wire';

export const permissionKeys = createQueryKeys('permission');

export interface EffectivePermissions {
  model: PermissionModel[];
  raw: PermissionEntry[];
}

// O legado não refazia a busca ao montar (`refetchOnMount: false`) e só renovava com o token (~1 h).
const ONE_HOUR = 60 * 60 * 1000;

/** Permissões efetivas do usuário logado, já cruzadas com o catálogo. */
export const effectivePermissionsQuery = () =>
  apiQuery(
    permissionKeys.custom('effective'),
    async ({ signal }): Promise<EffectivePermissions> => {
      const raw = await getEffectivePermissions(signal);
      return { model: fromApiDataModel(raw), raw };
    },
    { staleTime: ONE_HOUR },
  );

/** Para `beforeLoad`: garante as permissões no cache antes de abrir a rota. */
export function ensureEffectivePermissions(queryClient: QueryClient) {
  // `staleTime: 'static'`: usa o cache se houver, como o antigo ensureQueryData.
  return queryClient.query({ ...effectivePermissionsQuery(), staleTime: 'static' });
}
